module.exports = __webpack_public_path__ + "static/thegrowthacademy-f63233da73a4c8bdec12e2431a6cb176.svg";